module.exports = __webpack_public_path__ + "static/img/0.0624cd58.png";